interface DefinitionItem {
  label: string;
  body: string;
}

interface DefinitionListProps {
  items: DefinitionItem[];
}

export const DefinitionList = ({ items }: DefinitionListProps) => (
  <dl className="space-y-3">
    {items.map((item) => (
      <div key={item.label}>
        <dt className="font-semibold text-muted-foreground">{item.label}</dt>
        <dd className="mt-1 text-foreground">{item.body}</dd>
      </div>
    ))}
  </dl>
);
